import {SagaIterator} from 'redux-saga';
import {call, put, select} from 'redux-saga/effects';

import {getOrderReviewTotalsWithNewShipping} from 'desktop/pages/checkout/utils/orderReviewTotals/orderReviewTotals';
import {ApplicationStoreType} from 'desktop/store';
import {AddressType} from 'desktop/types/addressType';

import {saveBillingAddress} from '../../../reducers/deliveryStep/billingAddress/billingAddress';
import {saveShippingAddress} from '../../../reducers/deliveryStep/shippingAddress/shippingAddress';
import {updateOrderReviewTotals} from '../../../reducers/orderReviewTotals/orderReviewTotals';
import {getBillingAddress} from '../../../selectors/billingAddress/billingAddress';
import {getOrderReviewTotals} from '../../../selectors/orderReviewTotals/orderReviewTotals';
import {getShippingAddress} from '../../../selectors/shippingAddress/shippingAddress';
import {getSelectedShippingMethod} from '../../../selectors/shippingMethods/shippingMethods';

type TargetsType = {
    [key: string]: {
        action: (r: AddressType) => void;
        selector: (store: ApplicationStoreType) => void;
    };
};

export const targets: TargetsType = {
    billingAddress: {
        action: saveBillingAddress,
        selector: getBillingAddress,
    },
    shippingAddress: {
        action: saveShippingAddress,
        selector: getShippingAddress,
    },
};

/**
 * Update review total shipping info on shipping method change
 */
export function* updateOrderReviewShippingInfoSaga(): SagaIterator {
    const shippingMethod = yield select(getSelectedShippingMethod);
    const orderReviewTotals = yield select(getOrderReviewTotals);
    const newTotals = yield call(
        getOrderReviewTotalsWithNewShipping,
        orderReviewTotals.totals,
        shippingMethod,
    );

    yield put(updateOrderReviewTotals(newTotals));
}
